export enum ViewContext {
  List = "list",
  Detail = "detail",
  Drawer = "drawer",
}
